import { useEffect } from "react";
import { useGetAccountQuery } from "@/shared/services";
import { validateViewAnalyticsTimestamp } from "../utils";

export const useViewAnalyticsTimestamps = () => {
  const { data: account, isSuccess } = useGetAccountQuery();
  useEffect(() => {
    if (isSuccess && account) {
      validateViewAnalyticsTimestamp(account);
    }
  }, [account, isSuccess]);
};
